__turbopack_context__.v({
  "imageFooter": "vote-module-scss-module__HdHoJW__imageFooter",
  "privacyPolicy": "vote-module-scss-module__HdHoJW__privacyPolicy",
  "responsiveButton": "vote-module-scss-module__HdHoJW__responsiveButton",
  "votingBox": "vote-module-scss-module__HdHoJW__votingBox",
});
